import * as React from 'react';

import config from 'js/app/config';
import { useLocation } from 'js/lib/useRouter';

import { CourseRichSearchCard } from 'bundles/seo/components/course-rich-search-card/CourseRichSearchCard';
import { fromDescriptionPageCoursePage } from 'bundles/seo/components/course-rich-search-card/fromDescriptionPageCoursePage';
import type { CoursePrice } from 'bundles/seo/components/course-rich-search-card/types';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';

type Props = {
  pageData: ConsumerCoursePageFieldsFragment;
  coursePrice: CoursePrice;
};

export const CoursePageCourseRichSearchCard = (props: Props) => {
  const { pageData, coursePrice } = props;

  const location = useLocation();
  const url = `${config.url.base}${location.pathname.replace(/^\/+/, '')}`;

  const data = fromDescriptionPageCoursePage(pageData, coursePrice, url);

  if (data) {
    return <CourseRichSearchCard data={data} />;
  } else {
    return null;
  }
};
